"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const theme_1 = require("../theme");
const button_styled_1 = require("./button.styled");
const withDefaults = (props) => (Object.assign({}, props, { label: props.label || '', className: props.className || '', iconBefore: props.iconBefore || '', iconAfter: props.iconAfter || '', color: props.color || theme_1.palette.greyscale.dark, bgColor: props.bgColor || theme_1.palette.greyscale.light, hoverColor: props.hoverColor || props.bgColor || theme_1.palette.greyscale.light, activeColor: props.activeColor || props.activeColor || props.bgColor || theme_1.palette.greyscale.light, disabled: props.disabled || false, loading: props.loading || false }));
const buttonClasses = (styleProps) => {
    const { disabled, loading, className } = styleProps;
    const classes = [
        'button'
    ];
    if (disabled)
        classes.push('button--disabled');
    if (loading)
        classes.push('button--loading');
    if (className)
        classes.push(className);
    return classes.join(' ');
};
exports.Button = (props) => {
    const { label = '', disabled, loading, onClick, id, iconBefore, children, iconAfter } = props;
    const classes = buttonClasses(withDefaults(props));
    const handler = disabled || loading ?
        (e) => e.preventDefault() :
        onClick || ((_) => _);
    return React.createElement(button_styled_1.StyledButton, Object.assign({}, props, { id: id, "aria-label": label, className: classes, onClick: handler }),
        React.createElement("div", { className: `button__content${loading ? ' button__content--hidden' : ''}` },
            iconBefore && React.createElement("span", { className: "button__icon button__icon--before" }, iconBefore),
            children,
            iconAfter && React.createElement("span", { className: "button__icon button__icon--after" }, iconAfter)),
        loading && React.createElement("span", { className: "button__loader" }));
};
// Button (onClick)
// LinkButton (external/internal)
// Loader Button
//# sourceMappingURL=Button.js.map